import TaxiCorporationFleetPartnerAddRequest, {
  TaxiCorporationFleetPartnerAddRequestBody,
} from "./taxi-corporation-fleet-partner-add.request";

const createBody = (
  request: TaxiCorporationFleetPartnerAddRequest,
): TaxiCorporationFleetPartnerAddRequestBody => {
  return {
    name: request.name,
    notes: request.notes,
  };
};

const taxiCorporationFleetPartnerAddRequestFactory = {
  createBody,
};

export default taxiCorporationFleetPartnerAddRequestFactory;
